import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { environment } from '../environments/environment';
import { ContactUs } from '../models/contact-us';
import { BaseService } from '../base/base-service';


@Injectable({
  providedIn: 'root'
})
export class ContactUsService extends BaseService {

  readonly uris = {
    contactus: `api/${environment.api.version}/contact-us`,
  };



  contactUsRequest(request: ContactUs): Observable<any> {
    return this.http
      .post<any>(this.getUrl(`${this.uris.contactus}`, false), request)
      .pipe(
        switchMap(response => {
          return [response];
        }),
        catchError(error => {
          return [null];
        })
      );
  }
}
